<template>
  <div class="container">
    <img class="bg bg_top" src="./assets/images/main/bg_top_new.png" alt="" />
    <img class="bg bg_top_line" src="./assets/images/main/line.png" alt="" />
    <img
      class="bg bg_top_main"
      src="./assets/images/main/bg_main_t.png"
      alt=""
    />
    <div
      class="bg bg_left"
      :class="getLeftFold ? '' : 'left_fold_close'"
      v-if="!noFoldRoutes.includes($route.path)"
    >
      <img class="bg_left_top" :src="lt1ImgSrc" alt="" />
      <img class="bg_left_bottom" :src="lt2ImgSrc" alt="" />
    </div>
    <div
      class="bg bg_right"
      :class="getRightFold ? '' : 'right_fold_close'"
      v-if="!noFoldRoutes.includes($route.path)"
    >
      <img class="bg_right_top" :src="rt1ImgSrc" alt="" />
      <img class="bg_right_bottom" :src="rt2ImgSrc" alt="" />
    </div>

    <img
      class="bg bg_bottom_line"
      src="./assets/images/main/bg_main_b.png"
      alt=""
    />
    <img class="bg bg_bottom" src="./assets/images/main/bg_bottom.png" alt="" />

    <modheader></modheader>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <modfooter></modfooter>
  </div>
</template>

<script>
import modheader from "@/views/components/common/header";
import modfooter from "@/views/components/common/footer";
import { mapGetters } from "vuex";
export default {
  components: {
    modheader,
    modfooter,
  },
  name: "App",
  provide() {
    return { reload: this.reload };
  },
  data() {
    return {
      // 以下路由不显示左右侧
      noFoldRoutes: [
        "/governmentAffairs/purchaseAllowance",
        "/governmentAffairs/vehiclesupervisor",
        "/governmentAffairs/scrapSubsidy",
        "/new_cooperative",
        "/socialization",
      ],
      isRouterAlive: true,
      currentMenu: 2,
    };
  },
  computed: {
    ltColumnCount() {
      let count = 3;
      let self = this;
      const path = self.$route.path;
      if (path == "/aiDispatch") {
        count = 2;
      }
      return count;
    },
    rtColumnCount() {
      let count = 3;
      let self = this;
      const path = self.$route.path;
      if (path == "/aiDispatch") {
        count = 1;
      }
      return count;
    },
    lt1ImgSrc() {
      let self = this;
      return require(`./assets/images/main/bg_main_t_l_${self.ltColumnCount}.png`);
    },
    lt2ImgSrc() {
      let self = this;
      return require(`./assets/images/main/bg_main_l_${self.ltColumnCount}.png`);
    },
    rt1ImgSrc() {
      let self = this;
      return require(`./assets/images/main/bg_main_t_r_${self.rtColumnCount}.png`);
    },
    rt2ImgSrc() {
      let self = this;
      return require(`./assets/images/main/bg_main_r_${self.rtColumnCount}.png`);
    },
    ...mapGetters(["getLeftFold", "getRightFold"]),
  },
  created() {
    console.log("--------------------", this.getUrlParam("token"));
    /*     this.$store.dispatch("setActiveRegionName", "410000000"); */
  },
  mounted() {},
  methods: {
    getUrlParam(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      if (window.location.hash.indexOf("?") < 0) {
        return null;
      }
      let r = window.location.hash.split("?")[1].match(reg);
      if (r != null) return decodeURIComponent(r[2]);
      return null;
    },

    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style lang="scss">
@import "./assets/css/base.css";
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

body {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.container {
  width: 100%;
  height: 100vh;
  background-image: url("./assets/images/main/bg.png");
  background-size: cover;
}

.header_panel {
  pointer-events: none;
  width: 100%;
  height: vh(168);
  z-index: 100;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .header_top {
    pointer-events: all;
    flex: 1.2;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .header_bottom {
    pointer-events: all;
    flex: 2;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .title {
      font-size: fontSize(34);
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      letter-spacing: 9px;
    }
    .time_panel {
      text-shadow: 3px 1px 9px rgba(20, 200, 255, 0.48);
      font-size: fontSize(18);
      font-family: Bahnschrift;
      font-weight: 400;
      color: #ffffff;
      .week {
        margin: 0 vw(16);
      }
    }
  }
}

.bg {
  position: absolute;
  z-index: 1;
  pointer-events: none;
}
.bg_top {
  right: 0;
  left: 0;
  top: 0;
  width: 100%;
  height: vh(198);
  // z-index: 100;
}
.bg_top_line {
  width: vw(405);
  left: vw((1920-405)/2);
  top: vh(27);
  height: vh(93);
}
.bg_top_main {
  top: vh(68);
  width: vw(1920);
  height: vh(131);
}
.bg_left {
  top: vh(68);
  bottom: 0;
  left: 0;
  width: vw(548);
  height: vh(1080-68);
  display: flex;
  flex-direction: column;
  transition: all 300ms;
  &.left_fold_close {
    left: -100%;
    transition: all 300ms;
  }
  .bg_left_top {
    width: vw(548);
    height: vh(100);
  }
  .bg_left_bottom {
    width: vw(508);
    flex: 1;
  }
}
.bg_right {
  top: vh(68);
  bottom: 0;
  right: 0;
  width: vw(548);
  height: vh(1080-68);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  transition: all 300ms;
  &.right_fold_close {
    right: -100%;
    transition: all 300ms;
  }
  .bg_right_top {
    width: vw(548);
    height: vh(100);
  }
  .bg_right_bottom {
    width: vw(508);
    flex: 1;
  }
}
.bg_bottom_line {
  width: vw(904);
  height: vh(50);
  left: vw((1920-904)/2);
  bottom: 0;
}
.bg_bottom {
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: vh(120);
  z-index: 2;
}
</style>
